import React, { Component } from 'react';
import {Label, DatePickerCalendar, Button} from 'app/components/Basics/';
import { Select } from '@ecosystem/ui-lib/core/components/Select';
import './FiltersComponent.scss';
import {ResponseDownloadFormContext} from '../../EdiaryResponseDownloadNqContext'
import MultiSelect from 'app/components/MultiSelect'

class Filters extends Component {

    static contextType = ResponseDownloadFormContext;

    constructor(props){
        super(props);        
    }

	setStartDate(date) {		
		var selectedSelectionFilters = this.context.selectedSelectionFilters;
		selectedSelectionFilters.startDate = date;
		this.context.updateSelectedSelectionFilters(selectedSelectionFilters);
	}

	setEndDate(date) {
		var selectedSelectionFilters = this.context.selectedSelectionFilters;
		selectedSelectionFilters.endDate = date;
		this.context.updateSelectedSelectionFilters(selectedSelectionFilters);
	}

	changeMarketHandler(selectedItem) {
		var selectedSelectionFilters = this.context.selectedSelectionFilters;
		selectedSelectionFilters.regionId = selectedItem.value;		
		this.context.updateSelectedSelectionFilters(selectedSelectionFilters);
    }

	getSelectedMarketOption() {
        return this.props.metadata.regions?.find(t=> t.value === this.context.selectedSelectionFilters.regionId);
    }

	createOption(item, metadataList) {	
		if (!metadataList) { return null }
		var metadataItem = metadataList.find(m=>m.value === item);
		if (!metadataItem) { return null }

		return {
			value: item,
			label: metadataItem.label
		}
	}	

	getSelectedOptionsMultiSelect(metadata, selectedValues ) {		
		var result = [];		
		result = selectedValues.map(
			item => this.createOption(item, metadata)
		);		
		return result;
	}
	
	onChangeQuestion(items)  {		
		var selectedSelectionFilters = this.context.selectedSelectionFilters;
		selectedSelectionFilters.questions = [];
		selectedSelectionFilters.questions = items.map(x => x.value);		
		this.context.updateSelectedSelectionFilters(selectedSelectionFilters);       
	}

	onRemoveQuestion(item)  {		
		var selectedSelectionFilters = this.context.selectedSelectionFilters;		
		selectedSelectionFilters.questions = selectedSelectionFilters.questions.filter(function(f) { return f !== item.value });
		this.context.updateSelectedSelectionFilters(selectedSelectionFilters);
	}

	changeSurveyTypeHandler(selectedItem) {
		var selectedSelectionFilters = this.context.selectedSelectionFilters;
		selectedSelectionFilters.subSurveyId = parseInt(selectedItem.value);
		this.context.updateSelectedSelectionFilters(selectedSelectionFilters);
    }

	getSelectedSurveyTypeOption() {
        return this.props.metadata.surveyTypes?.find(t=> parseInt(t.value) === this.context.selectedSelectionFilters.subSurveyId);
    }

    render() {
        return (
            <div>
				<div className="FiltersComponent form-row">
					<div className="form-row-left">
						<div className="field-survey-from">
							<Label>Date From</Label>
							<DatePickerCalendar value={this.context.selectedSelectionFilters.startDate} onChange={this.setStartDate.bind(this)} />
						</div>
						<div className="field-survey-to">
							<Label>Date To</Label>
							<DatePickerCalendar value={this.context.selectedSelectionFilters.endDate} minDate={this.context.selectedSelectionFilters.startDate} onChange={this.setEndDate.bind(this)} />
						</div>
						<div className="field-market">
							<Label>Market</Label>
							<Select name="market" isSearchable={false}
								styles={{ option: styles => ({ minHeight: 40, ...styles }) }}                            
								onChange={val=>{
									this.changeMarketHandler(val)                                
								}}							
								options={this.props.metadata.regions}
								value={this.getSelectedMarketOption()}
								key={this.context.selectedSelectionFilters.regionId}
								>							
							</Select>
						</div>			
						<div className="field-surveytype">
							<Label>Survey Type</Label>
							<Select name="qsetsurveytype" isSearchable={false}
								key={this.context.selectedSelectionFilters.subSurveyId}
								styles={{ option: styles => ({ minHeight: 40, ...styles }) }}								
								onChange={val=>{
									this.changeSurveyTypeHandler(val)                                
								}}
								options={this.props.metadata.surveyTypes} 
								value={this.getSelectedSurveyTypeOption()}>
							</Select>
						</div>
					</div>
					<div className="form-row-right">
					</div>
            	</div>
				<div className="FiltersComponent form-row">
					<div className="form-row-left">
						<div className='questions-selection'>
							<Label tooltipPosition="right" tooltip="Select the question codes that apply for this csv download">Questions</Label>							
							<MultiSelect 
								selectedOptions={this.getSelectedOptionsMultiSelect(this.props.metadata.questions, this.context.selectedSelectionFilters.questions)} 
								onChange={this.onChangeQuestion.bind(this)} 
								onRemove={this.onRemoveQuestion.bind(this)} 
								options={this.props.metadata.questions}
								showSelectAll={true}>
							</MultiSelect>
						</div>				
					</div>					
            	</div>				
			</div>
        );
    }
}

Filters.contextType = ResponseDownloadFormContext;

export default Filters;